import styled from "styled-components";

export const StyledLoginPage = styled.div`
  background-color: ${(props: any) => props.backgroundColor};
  padding-top: 60px;
  height: calc(${(props: any) => props.height});
  min-height: 550px;
  width: ${(props: any) => props.width};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  font-family: ${(props: any) => props.fontFamily};
  a {
    color: white;
  }
  h2 {
    max-width: 90%;
    margin: 0;
    color: ${(props: any) => props.textColor};
    font-size: ${(props: any) => props.textSize}px;
    font-weight: ${(props: any) => props.textWeight};
    text-align: center;
  }
` as any;

export const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  max-height: 300px;
  .logo {
    max-width: 90%;
    object-fit: contain;
    width: 500px;
  }
` as any;

export const StyledLoginConatainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  max-width: 100%;
  img.loginButton {
    max-width: 90%;
    margin-bottom: 12px;
    cursor: pointer;
    &:active {
      transform: scale(95%);
    }
  }
  span {
    text-align: center;
    max-width: 80%;
    font-size: 12px;
  }
` as any;
